<template>
	<TypographyTitle :level="2">
		{{ $t('registration.header') }}
	</TypographyTitle>

	<div class="form-background max-width-750">
		<Form
			:model="formState"
			name="basic"
			:label-col="{ span: 8 }"
			:wrapper-col="{ span: 16 }"
			autocomplete="off"
			@finish="onFinish"
		>
			<FormItem
				:label="$t('registration.form.username')"
				name="username"
				:rules="[{ required: true, message: $t('registration.validators.username') }]"
			>
				<Input v-model:value="formState.username" ref="usernameField" />
			</FormItem>

			<FormItem
				:label="$t('registration.form.password')"
				name="password"
				:rules="[{ required: true, message: $t('registration.validators.password') }]"
			>
				<InputPassword v-model:value="formState.password" />
			</FormItem>

			<FormItem
				:label="$t('registration.form.roverId')"
				name="roverId"
				:rules="[{ required: true, message: $t('registration.validators.roverId') }]"
			>
				<Input v-model:value="formState.roverId" />
			</FormItem>

			<FormItem
				:label="$t('registration.form.roverPassword')"
				name="roverPassword"
				:rules="[{ required: true, message: $t('registration.validators.roverPassword') }]"
			>
				<InputPassword v-model:value="formState.roverPassword" />
			</FormItem>

			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }">
				<Button type="primary" html-type="submit" :disabled="isLoading" :loading="isLoading">{{ $t('registration.form.submitButtonLabel') }}</Button>
			</FormItem>

			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }" class="no-mg">
				<router-link :to="{ name: 'login' }">{{ $t('registration.loginLink') }}</router-link> {{ $t('registration.loginText') }}
			</FormItem>
		</Form>
	</div>
</template>

<script>
import { reactive, ref, toRaw } from 'vue';
import { TypographyTitle, Form, FormItem, Input, InputPassword, Button } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import { useFocusOnMounted } from '@/utils/useFocusOnMounted';
import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';

export default {
	components: {
		TypographyTitle, Form, FormItem, Input, InputPassword, Button,
	},
	setup() {
		const formState = reactive({
			username: '',
			password: '',
			roverId: '',
			roverPassword: '',
		});
		const isLoading = ref(false);
		const router = useRouter();
		const onFinish = () => {
			isLoading.value = true;
			Api.createUserAndGetToken(
				toRaw(formState),
				() => {
					isLoading.value = false;
					router.push({ name: 'activation-required' });
				},
				error => {
					isLoading.value = false;
					showErrorMessage(error.response.data);
				},
			);
		}

		const usernameField = ref();
		useFocusOnMounted(usernameField);
		return {
			formState,
			isLoading,
			onFinish,
			usernameField,
		};
	}
}
</script>
